export default "__VITE_ASSET__aa9e4b80__"